import { useEffect } from 'react';

// How close to its end a list still counts as being at its end, in px.
const NEAR_END = 48;

/**
 * Keep a scrolling list at its end while what is in it grows after it was
 * drawn. A chat answer is on screen before the app has read the records it
 * points at, and its rows fill in a moment later (MI-343): without this the
 * end of the answer slides out of view.
 *
 * A reader who scrolled up is left where they are. `mounted` is anything that
 * changes when the list's element is mounted again.
 */
export function useStickToBottom(ref, mounted) {
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof MutationObserver === 'undefined') return undefined;
    let atEnd = true;
    const onScroll = () => {
      atEnd = el.scrollHeight - el.scrollTop - el.clientHeight < NEAR_END;
    };
    const observer = new MutationObserver(() => {
      if (atEnd) el.scrollTop = el.scrollHeight;
    });
    el.addEventListener('scroll', onScroll, { passive: true });
    observer.observe(el, { childList: true, subtree: true, characterData: true });
    return () => {
      el.removeEventListener('scroll', onScroll);
      observer.disconnect();
    };
  }, [ref, mounted]);
}
